import React from "react";
import {Button, Form, Input, message} from "antd";
import {connect} from "react-redux";

import {
  hideMessage,
  showAuthLoader,
  userGoogleSignIn,
  userSignIn,
} from "appRedux/actions/Auth";
import CircularProgress from "components/CircularProgress/index";

const FormItem = Form.Item;

class SignIn extends React.Component {
  state = {
    toggle: false,
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.showAuthLoader();
        this.props.userSignIn(values);
      }
    });
  };

  handleToggleSignInManually = (e, toggle) => {
    e.preventDefault();
    this.setState({ toggle });
  };

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.authUser) {
      this.props.history.push('/');
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    const {toggle} = this.state;

    return (
      <div className="gx-app-login-wrap">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                <img src={require("assets/images/signin-bg.png")} alt='Neature'/>
              </div>
              <div className="gx-app-logo-wid">
              </div>
              <div className="gx-app-logo">
                <img style={{ width: 125 }} alt="example" src={require("assets/images/logo-white.png")}/>
                <span className="iconLogoText">Quotation</span>
              </div>
            </div>
            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                {!toggle ? <>
                  <div className="gx-flex-row gx-justify-content-between">
                    <Button className="login-btn" icon='google' onClick={() => {
                      this.props.showAuthLoader();
                      this.props.userGoogleSignIn();
                    }} type='primary' block>
                        Sign in with Google
                    </Button>
                  </div>
                  <FormItem style={{ textAlign: 'right' }}>
                    <Button onClick={e => this.handleToggleSignInManually(e, true)} type='link'>Sign in manually ?</Button>
                  </FormItem>
                </>
                : <>
                  <FormItem>
                    {getFieldDecorator('email', {
                      initialValue: "demo@example.com",
                      rules: [{
                        required: true, type: 'email', message: 'The input is not valid E-mail!',
                      }],
                    })(
                      <Input placeholder="Email"/>
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('password', {
                      initialValue: "123456",
                      rules: [{required: true, message: 'Please input your Password!'}],
                    })(
                      <Input type="password" placeholder="Password"/>
                    )}
                  </FormItem>
                  <FormItem style={{ textAlign: 'right' }}>
                    <Button onClick={e => this.handleToggleSignInManually(e, false)} icon='logout' type="link" className="gx-mb-0">
                      Go Back
                    </Button>
                    <Button icon='login' loading={loader} type="primary" className="gx-mb-0" htmlType="submit">
                      Sign in manually
                    </Button>
                  </FormItem>
                </>}
              </Form>
            </div>

            {loader ?
              <div className="gx-loader-view">
                <CircularProgress/>
              </div> : null}
            {showMessage ?
              message.error(alertMessage.toString(), 5) : null}
          </div>
        </div>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignIn);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  userGoogleSignIn,
})(WrappedNormalLoginForm);
